import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
import { TableCustom } from "../../components/Table";
import { NEWSLETTER_CONFIG_TABLE_KEYS } from "../../helper";
import * as XLSX from "xlsx";

const AllConfigs = () => {
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();

  const [userObjs, setUserObjs] = useState([]);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [configs,setConfigs] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  useEffect(() => {
    setIsUserLoading(true);
    axiosInstance
      .post("/newsletter/v2/all_configs/",{org_name:selectedOrgs})
      .then((res) => {
        setIsUserLoading(false);
        setConfigs(res.data || []);
        setOrgs(res?.data?.all_orgs);
      })
      .catch((err) => {
        setIsUserLoading(false);
      });
  }, [selectedOrgs]);

  const handleExportToXLSX = () => {
    try {
      setExportLoading(true);
      const columns = NEWSLETTER_CONFIG_TABLE_KEYS || [];
      const headers = columns.map((c) => c.label);
      const dataset = Array.isArray(configs?.data) ? configs.data : [];

      if (!dataset.length) {
        setExportLoading(false);
        alert("No data to export");
        return;
      }

      const rows = dataset.map((item) => {
        const row = {};
        columns.forEach((col) => {
          row[col.label] = item?.[col.key] ?? "";
        });
        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });

      // Auto column widths
      const colWidths = headers.map((header) => {
        const maxLen = Math.max(
          header?.toString()?.length || 0,
          ...rows.map((r) => (r[header] != null ? String(r[header]).length : 0))
        );
        return { wch: Math.min(Math.max(maxLen + 2, 8), 60) };
      });
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Configs");

      const ts = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .replace("T", "_")
        .slice(0, 19);
      const fileName = `newsletter-configs_${ts}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (err) {
      console.error("Failed to export XLSX", err);
      alert("Failed to export. Check console for details.");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="h-screen overflow-y-auto">
      <p className="text-base font-semibold  my-2 px-2 py-2 bg-white rounded-lg border">
        All Configurations
      </p>
      {isUserLoading ? (
        <>Loading...</>
      ) : (
        <div>
          <div className="flex justify-between pr-4">
            <p className="text-base font-semibold">Select Orgs</p>
            <button onClick={handleExportToXLSX} disabled={exportLoading} className="px-4 py-2 rounded text-sm bg-black font-medium text-white disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap">
              {exportLoading ? "Exporting..." : "Export to XLSX"}
            </button>
          </div>
           <div className="overflow-x-auto max-h-[400px] overflow-y-auto mt-4 border rounded-lg">
            <table className="w-full">
              <thead className="border-b text-left">
                <th className="px-2 py-1 text-gray-700 text-sm">Select</th>
                <th className="px-2 py-1 text-gray-700 text-sm">Org name</th>
              </thead>
              <tbody className="divide-y">
                {orgs?.map((s, index) => {
                  return (
                    <tr key={index} className="bg-white odd:bg-gray-50">
                      <td className="whitespace-nowrap px-2 py-2 font-normal text-gray-900">
                        <input 
                        onClick={()=>{
                            if(selectedOrgs.includes(s)){
                                setSelectedOrgs(prev=>prev.filter(it=>it!=s))
                            }else{
                                setSelectedOrgs(prev=>[...prev,s])
                            }
                        }}
                        checked={selectedOrgs.includes(s)}
                        type="checkbox" />
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 font-normal text-gray-900">
                        {s}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="mt-4 border rounded-lg">
          <TableCustom
            columns={NEWSLETTER_CONFIG_TABLE_KEYS}
            data={{'data':configs.data}}
            loading={isUserLoading}
            handleEdit={null}
            handleDelete={null}
            handleSelect={(id)=>{
              console.log(id)
              const configData = configs.data.find(it=>it.id === id)
              window.open(`${configData.base_url}dashboard/newsletter/v2/create?id=${configData.config_id}&type=${configData.newsletter_type.replace(' ','%20')}`,'_black')
            }}
            className="h-[35vh] max-w-full"
          />
          </div>
        </div>
      )}
    </div>
  );
};

export default AllConfigs;
